var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 23.18 25.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-3 {\n        fill: #fbbc04;\n      }\n\n      .cls-4 {\n        fill: #e94235;\n      }\n\n      .cls-5 {\n        fill: #4285f4;\n      }\n\n      .cls-6 {\n        fill: #34a853;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.59,
    y: 2.53,
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M21.19,12.75c0-.71-.06-1.39-.18-2.05H11.59v3.87h5.38c-.23,1.25-.94,2.31-2,3.02v2.51h3.23c1.89-1.74,2.98-4.3,2.98-7.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M11.59,22.53c2.7,0,4.96-.9,6.62-2.42l-3.23-2.51c-.9,.6-2.04,.95-3.39,.95-2.6,0-4.81-1.76-5.6-4.12H2.65v2.59c1.65,3.27,5.03,5.51,8.94,5.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5.99,14.43c-.2-.6-.31-1.24-.31-1.9s.11-1.3,.31-1.9v-2.59H2.65c-.68,1.35-1.06,2.88-1.06,4.49s.39,3.14,1.06,4.49l3.34-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11.59,6.5c1.47,0,2.79,.5,3.82,1.5l2.87-2.87c-1.73-1.61-4-2.6-6.69-2.6-3.91,0-7.29,2.24-8.94,5.51l3.34,2.59c.79-2.36,2.99-4.12,5.6-4.12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.6dd22899bf4b4f9a833a95429b5691f5.svg";
export { ForwardRef as ReactComponent };